
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import Multiselect from "vue-multiselect";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { DeviceDetails, DeviceService } from "@sureview/v2-cameras";
import { ShareWithPerson, EventDetails } from "@/store/site-monitor/types";

const SessionStore = namespace("sessions");
const SiteMonitor = namespace("siteMonitor");

@Component({
	components: {
		multiselect: Multiselect,
		VuePerfectScrollbar: VuePerfectScrollbar
	}
})
export default class EventSharing extends Vue {
	@Prop(Number) eventid?: number;

	$refs!: {
		sharingModal: any;
	};

	public settings: any = {};
	public selected: any[] = [];
	public isLoading: boolean = false;

	public adhocName: string = "";
	public adhocEmail: string = "";

	@SessionStore.Getter getSession: any;
	@SessionStore.Action updateSession: any;

	@SiteMonitor.Action loadExternalUsersAllowed: any;
	@SiteMonitor.Action removeShare: any;
	@SiteMonitor.Action updateSharing: any;
	@SiteMonitor.Action eventShareSearch: any;
	@SiteMonitor.Action eventPassControl: any;
	@SiteMonitor.Action loadNotificationTemplate: any;
	@SiteMonitor.Action shareEventWithUser: any;
	@SiteMonitor.Action shareEventWithGroup: any;
	@SiteMonitor.Action addAdhocEventShare: any;

	@SiteMonitor.Getter("getExternalUsersAllowed") externalEventShare!: boolean;
	@SiteMonitor.Getter("getEventShareShown") eventShareShown!: boolean;
	@SiteMonitor.Getter("getEventShare") sharedWith!: any[];
	@SiteMonitor.Getter shareWithPersons: ShareWithPerson[];
	@SiteMonitor.Getter("getAdhocShareDetails") adhocShareDetails: any;
	@SiteMonitor.Getter getEventDetails: EventDetails;

	@SiteMonitor.Mutation setEventShareShown: any;
	@SiteMonitor.Mutation setAdHocShareDetails: any;

	@Watch("eventShareShown")
	onEventCloseShownChanged(value: boolean, oldValue: boolean) {
		if (value) {
			this.$refs.sharingModal.show();
		} else {
			this.$refs.sharingModal.hide();
		}
	}

	created() {
		this.setEventShareShown(false);
		this.updateSession({ resourceId: 3 }); // eventId?
		this.loadExternalUsersAllowed(this.eventid);
	}

	async eventShareFind(query: any) {
		this.isLoading = true;
		try {
			await this.eventShareSearch(query);
			this.isLoading = false;
		} catch (e) {
			this.isLoading = false;
		}
	}

	async addImmixShare() {
		let sharePromises: Promise<any>[] = [];
		this.selected.forEach(share => {
			if (share.userID != null) {
				sharePromises.push(
					this.shareEventWithUser({
						UserID: share.userID,
						EventID: this.eventid,
						PassControl: false
					})
				);
			} else if (share.routingGroupID != null) {
				sharePromises.push(
					this.shareEventWithGroup({
						RoutingGroupID: share.routingGroupID,
						EventID: this.eventid,
						PassControl: false
					})
				);
			}
		});
		this.selected = [];

		let shareResults = [];

		for (var i = 0; i < sharePromises.length; i++) {
			shareResults.push(await sharePromises[i]);
		}

		//sharePromises.forEach(async (sharePromise) => {
		//	shareResults.push(await sharePromise);
		//});

		//Promise.all(sharePromises).then((shareResults: any[]) => {
		let notification: any = {};
		let anyNotification = false;

		shareResults.forEach(function(shareResult: any) {
			if (shareResult.notification != null && shareResult.notification.notificationServerID != null) {
				var notificationServerID = shareResult.notification.notificationServerID.toString();
				if (notification[notificationServerID] == null) notification[notificationServerID] = [];

				notification[notificationServerID].push(shareResult);
				anyNotification = true;
			}
		});

		if (anyNotification) {
			this.sendNotifications(notification);
		}

		this.updateSharing({ eventID: this.eventid });
		//});
	}

	async addAdhocShare() {
		const shareResult = await this.addAdhocEventShare({
			EventID: this.eventid,
			FullName: this.adhocName,
			Email: this.adhocEmail
		});

		this.adhocName = "";
		this.adhocEmail = "";

		if (shareResult.notification.notificationServerID != null) {
			const notification: any = {};
			notification[shareResult.notification.notificationServerID] = [shareResult];

			await this.updateSession({ resourceId: 3, eventId: this.eventid });
			this.sendNotifications(notification);
		}
	}

	sendNotifications(notification: any) {
		let deviceService = new DeviceService(this.getEventDetails.devicesEndpoint);
		let authSessionID = this.getSession("3");

		for (var notificationServerID in notification) {
			notification[notificationServerID].forEach(async (shareResult: any) => {
				let values = [
					{ Key: "FullName", Value: shareResult.fullName },
					{ Key: "EventID", Value: this.eventid },
					{ Key: "Email", Value: shareResult.notification.email },
					{ Key: "SharedBy", Value: shareResult.sharedBy },
					{ Key: "AccessCode", Value: shareResult.accessCode },
					{ Key: "ShareID", Value: shareResult.shareID },
					{ Key: "ShareLink", Value: shareResult.shareLink }
				];

				const template = await this.loadNotificationTemplate({
					TemplateName: "Event Sharing Template",
					ServerID: notificationServerID,
					Values: JSON.stringify(values)
				});

				const recipient = {
					Fullname: shareResult.fullName,
					ExternalID: shareResult.notification.externalID,
					Email: shareResult.notification.email,
					Telephone: shareResult.notification.telephone
				};

				const message = {
					Content: template.content,
					Subject: template.subject,
					Parameters: []
				};

				deviceService.sendNotification(authSessionID, parseInt(notificationServerID), [recipient], message);
			});
		}
	}

	closeSharing() {
		this.setEventShareShown(false);
	}

	async passControl(share: any) {
		await this.eventPassControl({
			eventID: this.eventid,
			userID: share.userID
		});
		this.closeSharing();
	}

	removeEventShare(share: any) {
		this.removeShare({ eventID: this.eventid, eventUserID: share.eventUserID });
	}
}
